import $ from 'jquery';
import  'slick-carousel';
import  '../components/_popin-pro';
import print from 'print-js';

$(document).ready(function () {

  $('[js-product-slider]').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    fade: true,
    arrows: false,
    asNavFor: '[js-product-slider-thumbnails]',
    adaptiveHeight: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          draggable: false
        }
      }
    ]
  });

  $('[js-product-slider-thumbnails]').slick({
    infinite: true,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 500,
    focusOnSelect: true,
    asNavFor: '[js-product-slider]',
    mobileFirst: true,
    responsive: [
      // sm
      {
        breakpoint: 720,
        settings: {
          slidesToShow: 5
        }
      },
      // md
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 3
        }
      },
      // lg
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 5
        }
      }
    ]
  });

});



// WEBPACK FOOTER //
// ./assets/scripts/pages/product.js